<template>
<div>
    <eat-list
        :event-type="eventType"
    />
</div>
</template>

<script>
import { ref, onUnmounted } from "@vue/composition-api";
import EatList from '../components/event-list/EventList.vue'

export default {
    components: {
        EatList
    },
    setup() {
        const eventType = ref('eat')

        return {
            eventType,
        }
    }
}
</script>